import styled from "styled-components";

const highFiveSprite = "https://ui-cdn.digitalocean.com/shared/high-five-sprite.png";

export const HighFive = styled.div`
  position: absolute;
  width: 305px;
  height: 225px;
  background: url(${highFiveSprite}) no-repeat 0 0;
  animation: high-five 3s steps(89);
  transform: translateZ(0);

  @keyframes high-five {
    100% {
      background-position: -26700px;
    }
  }
`;
